/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SensorData model module.
 * @module model/SensorData
 * @version 1.1.0
 */
class SensorData {
    /**
     * Constructs a new <code>SensorData</code>.
     * A representation of a Sensor object.
     * @alias module:model/SensorData
     * @param id {String} 
     * @param data {String} String of JSONized data
     * @param status {String} 
     * @param connection {String} 
     * @param timeLastUpdate {Date} 
     */
    constructor(id, data, status, connection, timeLastUpdate) { 
        
        SensorData.initialize(this, id, data, status, connection, timeLastUpdate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, data, status, connection, timeLastUpdate) { 
        obj['id'] = id;
        obj['data'] = data;
        obj['status'] = status;
        obj['connection'] = connection;
        obj['timeLastUpdate'] = timeLastUpdate;
    }

    /**
     * Constructs a <code>SensorData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SensorData} obj Optional instance to populate.
     * @return {module:model/SensorData} The populated <code>SensorData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorData();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('connection')) {
                obj['connection'] = ApiClient.convertToType(data['connection'], 'String');
            }
            if (data.hasOwnProperty('timeLastUpdate')) {
                obj['timeLastUpdate'] = ApiClient.convertToType(data['timeLastUpdate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SensorData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SensorData</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SensorData.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['data'] && !(typeof data['data'] === 'string' || data['data'] instanceof String)) {
            throw new Error("Expected the field `data` to be a primitive type in the JSON string but got " + data['data']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }
        // ensure the json data is a string
        if (data['connection'] && !(typeof data['connection'] === 'string' || data['connection'] instanceof String)) {
            throw new Error("Expected the field `connection` to be a primitive type in the JSON string but got " + data['connection']);
        }

        return true;
    }


}

SensorData.RequiredProperties = ["id", "data", "status", "connection", "timeLastUpdate"];

/**
 * @member {String} id
 */
SensorData.prototype['id'] = undefined;

/**
 * String of JSONized data
 * @member {String} data
 */
SensorData.prototype['data'] = undefined;

/**
 * @member {String} status
 */
SensorData.prototype['status'] = undefined;

/**
 * @member {String} connection
 */
SensorData.prototype['connection'] = undefined;

/**
 * @member {Date} timeLastUpdate
 */
SensorData.prototype['timeLastUpdate'] = undefined;






export default SensorData;

